module.exports = __webpack_public_path__ + "static/media/galdisa_servicios_ciclo_cultivo_3.af6440d6.jpg";